export function getGiphyOrigin() {
    if (!process.env.GIPHY_HOST) {
        return null
    }

    return `${process.env.GIPHY_PROTOCOL || 'https://'}${process.env.GIPHY_HOST}`
}
